// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__N1Ui8","inputDescription":"styles_inputDescription__1mSTw"};